// Snapshot fields for rows that reference a contact (quotes, invoices, field_jobs).
// Intent: frozen-at-insert. The snapshot reflects the contact at row creation
// and is not refreshed on contact edit. Intended for PDFs/emails. Keep
// company_name = null (never '') when there's no company affiliation, so the
// writer-set produces consistent values and the NULL/'' split that previously
// plagued invoices doesn't return.

export type ContactSnapshotInput = {
  first_name: string
  last_name?: string | null
  company_name?: string | null
}

export function contactSnapshot(c: ContactSnapshotInput): {
  contact_name: string
  company_name: string | null
} {
  return {
    contact_name: `${c.first_name} ${c.last_name || ''}`.trim(),
    company_name: c.company_name || null,
  }
}
